import React from "react";

const CardSvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M4.49999 7.20005L1.79999 4.50005M1.79999 4.50005L4.49999 1.80005M1.79999 4.50005H16.2M13.5 10.8L16.2 13.5M16.2 13.5L13.5 16.2M16.2 13.5H1.79999"
      stroke="#757373"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CardSvgIcon;
